/**
 * How the AI addresses the person — the same rule as the backend `person_scope.resolve_call_name`
 * (owner 2026-10-27). Keep the two identical.
 *
 *   call_by "given" → 名 / "family" → 氏 / "full" → 氏名 (or the POS name).
 *   Not chosen yet: 名 if set (people who set 名 under the old 「AIは名で呼びかけます」 label keep it),
 *   else 氏 (the Japanese default), else the full POS name (it has no space to split 氏 from 名).
 */

const HONORIFICS = ['さん', 'ちゃん', 'くん', '君'];

function stripHonorific(name) {
  const s = String(name || '').trim();
  const hit = HONORIFICS.find((h) => s.length > h.length && s.endsWith(h));
  return hit ? s.slice(0, -hit.length).trim() : s;
}

/** @returns {string} the name only, without さん */
export function resolveCallName(profile, posName) {
  const pos = String(posName || '').trim();
  const given = String(profile?.given_name || '').trim();
  const family = String(profile?.family_name || '').trim();
  const by = profile?.call_by;
  let name;
  if (by === 'given' && given) name = given;
  else if (by === 'family' && family) name = family;
  else if (by === 'full') name = family && given ? `${family}${given}` : pos;
  else name = given || family || pos;
  return stripHonorific(name || pos);
}

/** 'さん' by default; '' when the person asked for no honorific (stored as 'なし'). */
export function resolveCallSuffix(profile) {
  const s = profile?.call_suffix;
  if (s === 'なし') return '';
  return s === 'ちゃん' || s === 'くん' ? s : 'さん';
}

/**
 * Greeting for a chat / banner about `posName`. Only the person themself gets their saved 呼び方;
 * anyone else (manager viewing a stylist) is the POS name + さん, as before.
 */
export function greetingFor(myProfile, posName) {
  const isOwn = Boolean(myProfile?.stylist_name_pos) && myProfile.stylist_name_pos === posName;
  if (!isOwn) return { name: posName || '', suffix: 'さん', isOwn: false };
  return { name: resolveCallName(myProfile, posName), suffix: resolveCallSuffix(myProfile), isOwn: true };
}
